export default "__VITE_ASSET__DznjqVKH__"